import React from "react";  

const Navbar = () => {
  return (
    <div className="w-full sticky-top" style={{ background:"#2F4F4F", zIndex:"1"}}>
      <div className="container nav_bar">
        <nav class="navbar navbar-expand-md" style={{background:"#2F4F4F"}}>
          <div className="container-fluid">
            <div class="container">
            <a class="navbar-brand text-white" href="#">Akash</a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                  <a class="nav-link active" aria-current="page" href="#home">Home</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" aria-current="page" href="#skills">Skills</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" aria-current="page" href="#projects">Projects</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" aria-current="page" href="#experience">Experience</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" aria-current="page" href="#faq">FAQ</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" aria-current="page" href="#contact">Contact</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;


// Home    